<h2 mat-dialog-title>
  <mat-icon>perm_identity</mat-icon>
  {{ tableConfig.headerTitle }}
</h2>

<mat-dialog-content>
  <loading></loading>
  <div class="management">
    <div class="management__filter">
        <mat-form-field>
          <input
            matInput
            [(ngModel)]="tableConfig.filterValue"
            (keyup)="tableConfig.applyFilter($event.target.value)"
            placeholder="Search"
          />
        </mat-form-field>
      </div>
      <div class="management__table">
        <div class="management__table-content">
          <table
            mat-table
            [dataSource]="tableConfig.dataSource"
            matSort
            [matSortActive]="tableConfig.defaultSort?.column"
            [matSortDirection]="tableConfig.defaultSort?.direction"
          >
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  *ngIf="selection.isMultipleSelection()"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="selection.isMultipleSelection(); else radioBtn">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                    [disabled]="isSelectionDisabled(row)"
                    [aria-label]="checkboxLabel(row)"
                  >
                  </mat-checkbox>
                </ng-container>
                <ng-template #radioBtn>
                  <mat-radio-button
                    (click)="$event.stopPropagation()"
                    (change)="selection.select(row)"
                    [checked]="selection.isSelected(row)"
                  >
                  </mat-radio-button>
                </ng-template>
              </td>
            </ng-container>

            <ng-container *ngFor="let c of tableConfig.displayedColumns">
              <ng-container *ngIf="c != 'select'">
                <ng-container [matColumnDef]="c">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ tableConfig.columnsConfig[c].title }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      getViewValue(element[tableConfig.columnsConfig[c].name])
                    }}
                  </td>
                </ng-container>
              </ng-container>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="tableConfig.displayedColumns; sticky: true"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: tableConfig.displayedColumns"
            ></tr>
          </table>
        </div>

        <div
          class="management__table-info"
          *ngIf="!isLoading && !tableConfig.dataSource?.filteredData?.length"
        >
          <h3 class="color-primary">No Data</h3>
        </div>
      </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <div [matTooltip]="addBtnTooltip">
    <button
      [disabled]="isAddButtonDisabled"
      mat-flat-button
      color="primary"
      (click)="add()"
    >
      Add
    </button>
  </div>
</mat-dialog-actions>
